import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "../components/layout/Header/Header.jsx";
import Footer from "../components/layout/Footer/Footer.jsx";
import { motion } from "framer-motion";

// Импорт изображений (аналогично секциям)
import imgExtreme1 from "../components/sections/ExtremeSection/Rectangle 10.webp";
import imgExtreme2 from "../components/sections/ExtremeSection/Rectangle 12.webp";
import imgExtreme3 from "../components/sections/ExtremeSection/Rectangle 13.webp";
import imgExtreme4 from "../components/sections/ExtremeSection/Rectangle 14.webp";
import imgExtreme5 from "../components/sections/ExtremeSection/Rectangle 15.webp";

import imgCultural1 from "../components/sections/CulturalSection/fotosession.webp";
import imgCultural2 from "../components/sections/CulturalSection/kater.webp";
import imgCultural3 from "../components/sections/CulturalSection/water.webp";
import imgCultural4 from "../components/sections/CulturalSection/ysypovskie.webp";
import imgCultural5 from "../components/sections/CulturalSection/zagorod.webp";

import imgOutdoor1 from "../components/sections/OutdoorSection/Rectangle 13.webp";
import imgOutdoor2 from "../components/sections/OutdoorSection/Rectangle 10.webp";
import imgOutdoor3 from "../components/sections/OutdoorSection/Rectangle 11.webp";
import imgOutdoor4 from "../components/sections/OutdoorSection/Rectangle 12.webp";
import imgOutdoor5 from "../components/sections/OutdoorSection/Rectangle 1.webp";

import imgTransfer from "../components/sections/ServicesSection/transferImage.webp";
import imgGuide from "../components/sections/ServicesSection/gidImage.webp";

// Изображения из PreviewSection
import imgPreviewBalet from "../components/sections/previewSection/balet.webp";
import imgPreviewCirk from "../components/sections/previewSection/image2.webp";
import imgPreviewErmitajh from "../components/sections/previewSection/ermitajh.webp";
import imgPreviewPetergof from "../components/sections/previewSection/petergof.webp";

// Можно расширить мапу изображений для других секций
const imagesMap = {
  "extreme-1": imgExtreme1,
  "extreme-2": imgExtreme2,
  "extreme-3": imgExtreme3,
  "extreme-4": imgExtreme4,
  "extreme-5": imgExtreme5,

  "cultural-1": imgCultural1,
  "cultural-2": imgCultural2,
  "cultural-3": imgCultural3,
  "cultural-4": imgCultural4,
  "cultural-5": imgCultural5,

  "outdoor-1": imgOutdoor1,
  "outdoor-2": imgOutdoor2,
  "outdoor-3": imgOutdoor3,
  "outdoor-4": imgOutdoor4,
  "outdoor-5": imgOutdoor5,

  transfer: imgTransfer,
  guide: imgGuide,

  "preview-balet": imgPreviewBalet,
  "preview-cirk": imgPreviewCirk,
  "preview-ermitajh": imgPreviewErmitajh,
  "preview-petergof": imgPreviewPetergof,
};

const ServicePage = () => {
  const { lang, serviceId } = useParams();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (lang && i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
    window.scrollTo(0, 0);
  }, [lang, i18n]);

  // Предполагаем, что в переводах будет секция "serviceDetails" с ключами, равными serviceId
  const serviceData = t(`serviceDetails.${serviceId}`, { returnObjects: true });

  // Если данных нет, можно либо показать заглушку, либо редирект на 404
  if (!serviceData || typeof serviceData === "string") {
    return (
      <>
        <Header />
        <div className="py-32 text-center container mx-auto px-4">
          <h1 className="text-4xl font-bold mb-4">{t("notFound.title")}</h1>
          <button
            onClick={() => navigate(`/${i18n.language}`)}
            className="px-6 py-2 bg-black text-white rounded-lg hover:bg-gray-800 transition-colors"
          >
            {t("notFound.backHome")}
          </button>
        </div>
        <Footer />
      </>
    );
  }

  const {
    title,
    description,
    price,
    longDescription,
    features,
    duration,
    transport,
    languages,
    priceRange,
    bestTime,
    idealFor,
  } = serviceData;
  const image = imagesMap[serviceId];

  return (
    <>
      <Header />
      <nav className="fixed left-8 top-20 z-50 bg-white/30 py-2 px-4 rounded-2xl border border-white ">
        <button
          onClick={() => navigate(-1)}
          className=" text-black transition-colors flex items-center gap-2  "
        >
          ← {t("common.back", "Назад")}
        </button>
      </nav>{" "}
      <main className=" relative">
        <div className="h-[75vh] relative ">
          <h1 className="w-full h1_mod_size min-w-xs text_color-white text-shadow-[0_0_10px_rgba(0,0,0,0.5)] absolute top-1/2 transform -translate-y-1/2 text-center ">
            {title}
          </h1>
          <p className="max-w-xl absolute right-8 bottom-8 transform text-shadow-[0_0_10px_rgba(0,0,0,0.5)] text-xl text_color-white leading-relaxed italic border-l-4 border-amber-500 pl-6">
            {description}
          </p>{" "}
          {image ? (
            <img
              src={image}
              alt={title}
              className=" w-full h-full object-cover "
            />
          ) : (
            <div className=" bg-gray-200 flex items-center justify-center text-gray-400">
              No Image
            </div>
          )}
        </div>
        <div className="container mx-auto px-4">
          <div className="text-2xl font-semibold text-amber-600 my-8">
            {price}
          </div>
          {longDescription && (
            <div className="my-8 text-gray-600 leading-relaxed text-lg">
              {longDescription.split("\n\n").map((paragraph, idx) => (
                <p key={idx} className="mb-4">
                  {paragraph}
                </p>
              ))}
            </div>
          )}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="mb-8"
          >
            <div className="grid h-full grid-cols-1  lg:grid-cols-2 gap-y-12 lg:gap-x-8  text-gray-700 bg-gray-50 p-6 rounded-xl border border-gray-100">
              {transport && (
                <div className="min-w-[200px]">
                  <span className="font-bold block text-sm text-gray-500 uppercase tracking-wider mb-1">
                    {t("servicePage.transport", "Трансорт")}
                  </span>
                  <span className="text-lg">{transport}</span>
                </div>
              )}
              {languages && (
                <div className="min-w-[200px]">
                  <span className="font-bold block text-sm text-gray-500 uppercase tracking-wider mb-1">
                    {t("servicePage.languages", "Доступные языки")}
                  </span>
                  <span className="text-lg">{languages}</span>
                </div>
              )}
              {priceRange && (
                <div className="min-w-[200px]">
                  <span className="font-bold block text-sm text-gray-500 uppercase tracking-wider mb-1">
                    {t("servicePage.priceRange", "Диапазон цен")}
                  </span>
                  <span className="text-lg">{priceRange}</span>
                </div>
              )}

              {idealFor && (
                <div className="min-w-[200px]">
                  <span className="font-bold block text-sm text-gray-500 uppercase tracking-wider mb-1">
                    {t("servicePage.idealFor", "Идеально подойдет")}
                  </span>
                  <span className="text-lg">{idealFor}</span>
                </div>
              )}
              {bestTime && (
                <div className="">
                  <span className=" font-bold block text-sm text-gray-500 uppercase tracking-wider mb-1">
                    {t("servicePage.bestTime", "Лучшее время начала")}
                  </span>
                  <span className="text-lg">{bestTime}</span>
                </div>
              )}
              {duration && (
                <div className="">
                  <span className="font-bold  block text-sm text-gray-500 uppercase tracking-wider mb-1">
                    {t("servicePage.duration", "Время экскурсии")}
                  </span>
                  <span className="text-lg">{duration}</span>
                </div>
              )}
              {features && Array.isArray(features) && (
                <div className="lg:mb-10 ">
                  <h3 className="text-xl font-bold mb-4">
                    {t("servicePage.features", "Особенности:")}
                  </h3>
                  <ul className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {features.map((feature, index) => (
                      <li key={index} className="flex items-start gap-3">
                        <span className="text-amber-500 mt-1">✓</span>
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </motion.div>

          {/*<div className="mt-auto">*/}
          {/*  <button className="w-full md:w-auto px-10 py-4 bg-black text-white rounded-full text-lg font-semibold hover:bg-gray-800 transition-all transform hover:scale-105">*/}
          {/*    {t("header.application")}*/}
          {/*  </button>*/}
          {/*</div>*/}
        </div>
      </main>
      <Footer />
    </>
  );
};

export default ServicePage;
